import React, { useState, useEffect } from 'react';
import './Verification.css';
import { verifyOTP, resendOTP } from '../services/authService';

const Verification = ({ phoneNumber, onBack, onVerificationSuccess }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [timeLeft, setTimeLeft] = useState(55);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 4) {
      setOtp(value);
    }
    if (error) setError('');
  };

  const validateOtp = () => {
    if (!otp.trim()) {
      setError('Please enter the verification code');
      return false;
    }
    if (otp.length < 4) {
      setError('Please enter a valid 4-digit code');
      return false;
    }
    return true;
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!validateOtp()) {
      return;
    }

    setLoading(true);

    try {
      const data = await verifyOTP(phoneNumber, otp);
      setSuccessMessage(data.message || 'Verification successful!');
      setOtp('');
      
      // Redirect based on role - extract from nested user object or top level
      if (onVerificationSuccess) {
        setTimeout(() => {
          const role = data.user?.role || data.role || 'guest';
          const user = data.user || null;
          const token = data.token || null;
          console.log('Verification response:', data);
          console.log('Extracted role:', role);
          console.log('User data:', user);
          console.log('Token:', token);
          onVerificationSuccess(role, user, token);
        }, 1500);
      }
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'Failed to verify OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setSuccessMessage('');
    setLoading(true);

    try {
      const data = await resendOTP(phoneNumber);
      setSuccessMessage(data.message || 'OTP resent successfully!');
      setTimeLeft(55);
      setCanResend(false);
      setOtp('');
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'Failed to resend OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verification-container">
      <div className="verification-box">
        <div className="verification-brand">INSAFAPP.COM</div>
        <div className="verification-header">
          <button className="back-button" onClick={onBack} disabled={loading}>
            ←
          </button>
          <h1>Verification</h1>
          <div className="header-spacer"></div>
        </div>

        <div className="verification-divider"></div>

        <div className="verification-content">
          <p className="verification-message">
            4-digit Verification Code has been Sent to <strong>{phoneNumber}</strong>
          </p>

          <form onSubmit={handleVerify}>
            <div className="form-group">
              <label htmlFor="otp" className="otp-label">Verification Code</label>
              <input
                id="otp"
                type="text"
                inputMode="numeric"
                value={otp}
                onChange={handleOtpChange}
                placeholder="0000"
                className={`otp-input ${error ? 'error' : ''}`}
                disabled={loading}
                maxLength="4"
              />
              <span className="otp-character-count">{otp.length}/4</span>
            </div>

            {error && <div className="error-message">{error}</div>}
            {successMessage && <div className="success-message">{successMessage}</div>}

            <div className="resend-section">
              <span className="resend-text">Didn't get code?</span>
              <button
                type="button"
                className="resend-button"
                onClick={handleResend}
                disabled={!canResend || loading}
              >
                {canResend ? 'Resend now' : `Resend in ${timeLeft}s`}
              </button>
            </div>

            <button
              type="submit"
              className={`verify-button ${loading ? 'loading' : ''}`}
              disabled={loading}
            >
              {loading ? 'Verifying...' : 'Verify'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Verification;
